import { createSelector } from 'reselect';

import { CalendarPlanShowcaseStore } from './typings';

const storeSelector = <T extends { calendarPlanShowcase: CalendarPlanShowcaseStore }>(
    storeState: T
): CalendarPlanShowcaseStore => storeState.calendarPlanShowcase;

export const getIsCalendarPlanOpened = createSelector(storeSelector, (store) => store.isCalendarPlanOpened);
